export const MOSCOW_GEO = {
  id: 22823,
  name: 'Москва',
  country: 'Россия',
  countryId: 20,
  popularity: 1,
  trans: 'moskva',
  countryCode: 'RU',
};

export const SAINT_PETERSBURG_GEO = {
  id: 22871,
  name: 'Санкт-Петербург',
  country: 'Россия',
  countryId: 20,
  popularity: 0.999410029498525,
  trans: 'sankt-peterburg',
  countryCode: 'RU',
};
